<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="num_fiscal" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nº Fiscal</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="emi_cnpj" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">CPNJ Emitente</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="chave" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Chave</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <b-form-datepicker
                        locale="pt-br" 
                        reset-button
                        placeholder="Data Inicial" 
                        v-model="dt_inicio" 
                        class="form-control" 
                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <b-form-datepicker
                        locale="pt-br" 
                        reset-button
                        placeholder="Data Fim" 
                        v-model="dt_fim" 
                        class="form-control" 
                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-l">
                        <b-container>
                            <b-col sm="12" md="12">
                                <b-form-checkbox v-model="ocultar"
                                                 value="1"
                                                 unchecked-value="2">
                                  Ocultados <span v-b-tooltip title="Se marcado irá retornar documentos ocultados na listagem" placement="top">[?]</span>
                                </b-form-checkbox>
                            </b-col>
                        </b-container>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                            <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                          </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
	    </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
      num_fiscal: '',
      emi_cnpj: '',
      chave: '',
      ocultar: '',
      dt_inicio: '',
      dt_fim: '',
      data_filter: [],
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.dt_inicio_label = this.dt_inicio;
          this.dt_fim_label = this.dt_fim;
          this.dt_inicio = this.formatDateSubmit(this.dt_inicio);
          this.dt_fim = this.formatDateSubmit(this.dt_fim);
          this.data_filter = {num_fiscal: this.num_fiscal,
                              chave: this.chave,
                              ocultar: this.ocultar,
                              emi_cnpj: this.emi_cnpj,
                              dt_inicio: this.dt_inicio,
                              dt_fim: this.dt_fim};
          this.$events.fire('filter-set', this.data_filter);
          this.dt_inicio = this.dt_inicio_label;
          this.dt_fim = this.dt_fim_label;
      },
      formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
          return (value == null || value == "")
            ? ''
            : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
      },
      resetFilter () {
        this.num_fiscal = '';  // clear the text in text input
        this.emi_cnpj = '';
        this.chave = '';
        this.ocultar = '';
        this.dt_inicio = '';
        this.dt_fim = '';
        this.$events.fire('filter-reset');
      },
  },
   computed: {
       vuetableFilterButton: {
           get () {
               return this.$store.state.vuetable.filterButton;
           },
       },
   }
}
</script>
